import { useTranslation } from "react-i18next";
import { Add } from "iconsax-react";
import { Button } from "@/shared/ui";
import { useAuth } from "@/shared/hooks";
import { PERMISSIONS } from "@/shared/consts/permissions";

interface Props {
  onAddClick: () => void;
}

export default function VolunteersHeader({ onAddClick }: Props) {
  const { t } = useTranslation("VolunteersPage");
  const { hasPermission } = useAuth();

  return (
    <div className="flex items-center justify-between pb-4 pt-1 border-b surface-base-stroke mb-5">
      <h1 className="text-display-xs content-base-primary">{t("header.title")}</h1>
      {hasPermission(PERMISSIONS.PROJECTS.CREATE_VOLUNTEER) && (
        <Button variant="primary" size="huge" onClick={onAddClick}>
          <Add size={16} color="currentColor" />
          {t("header.addVolunteer")}
        </Button>
      )}
    </div>
  );
}

